// extracted by mini-css-extract-plugin
export default {"buttonsAction":"pixasso-modal_buttonsAction__CGHeF","button":"pixasso-modal_button__G2YuP","yesButton":"pixasso-modal_yesButton__jiOVr","noButton":"pixasso-modal_noButton__6+86x"};